import {onDOMReady} from './dom';

onDOMReady(function () {
    const yearSelect = document.querySelector('.filterVehicle__vehicle__yearSelection select');

    if (yearSelect) {
        const form = yearSelect.closest('form');
        yearSelect.addEventListener('change', function() {
            form.action = form.action.replace('__year__', encodeURIComponent(this.value || ''));
            form.submit();
        });
    }
});